(function() {
  'use strict';

  angular.module('app.owner', []);
})();
